import "../legacy-app.js";
import { initReferenceFileInputsFeature } from "./reference-file-inputs";
import { initInputSourcesFeature } from "./input-sources";
import { initImageEditorFeature } from "./image-editor";
import { initImageStripFeature } from "./image-strip";
import { initGalleryCategoriesFeature } from "./gallery-categories";
import { initRecentAssetsFeature } from "./recent-assets";
import { initQuickGalleryFeature } from "./quick-gallery";
import { initGalleryGridFeature } from "./gallery-grid";
import { initGalleryItemActionsFeature } from "./gallery-item-actions";
import { initGalleryFeature } from "./gallery";
import { initApiSettingsFeature } from "./api-settings";
import { initApiAdvancedSettingsFeature } from "./api-advanced-settings";
import { initStorageSettingsFeature } from "./storage-settings";
import { initNetworkEgressSettingsFeature } from "./network-egress-settings";
import { initSystemSettingsFeature } from "./system-settings";
import { initColorPaletteFeature } from "./color-palette";
import { initPromptColorsFeature } from "./prompt-colors";
import { initPromptSnippetsFeature } from "./prompt-snippets";
import { initPromptTemplatesFeature } from "./prompt-templates";
import { initPromptFeature } from "./prompt";
import { initPromptFidelityHelpFeature } from "./prompt-fidelity-help";
import { initPromptFindReplaceFeature } from "./prompt-find-replace";
import { initFormControlsFeature } from "./form-controls";
import { initOutputSettingsLockFeature } from "./output-settings-lock";
import { initTaskListRenderFeature } from "./task-list-render";
import { initTaskHistoryAnchorsFeature } from "./task-history-anchors";
import { initTaskArchiveControlsFeature } from "./task-archive-controls";
import { initTaskBatchControlsFeature } from "./task-batch-controls";
import { initTaskActionsFeature } from "./task-actions";
import { initTaskSubmitFeature } from "./task-submit";
import { initTaskListControlsFeature } from "./task-list-controls";
import { initTaskListQueueControlsFeature } from "./task-list-queue-controls";
import { initTaskContextMenuFeature } from "./task-context-menu";
import { initTaskNotificationsFeature } from "./task-notifications";
import { initTaskDerivedFeature } from "./task-derived";
import { initTaskPreviewFeature } from "./task-preview";
import { initTaskFeature } from "./tasks";
import { initTaskSelectionFeature } from "./task-selection";
import { initOverlayPopoversFeature } from "./overlay-popovers";
import { initShellUiFeature } from "./shell-ui";
import { initAppVersionFeature } from "./app-version";
import { initLightboxFeature } from "./lightbox";
import { initializeQueueFeature } from "./queue";
import { initSegmentedIndicatorFeature } from "./segmented-indicator";
import { initAspectRatioControlsFeature } from "./aspect-ratio-controls";
import { initI18nFeature } from "./i18n";
import { initModelCatalogFeature } from "./model-catalog";
import { initModelParameterDraftFeature } from "./model-parameter-drafts";
import { initModelParametersFeature } from "./model-parameters";
import { initTaskParameterInspectorFeature } from "./task-parameter-inspector";
import { initModelSelectionFeature } from "./model-selection";
import { initProviderSelectionFeature } from "./provider-selection";
import { initThemedSelectFeature } from "./themed-select";

initReferenceFileInputsFeature();
initInputSourcesFeature();
initImageEditorFeature();
initImageStripFeature();
initGalleryCategoriesFeature();
initRecentAssetsFeature();
initQuickGalleryFeature();
initGalleryGridFeature();
initGalleryItemActionsFeature();
initGalleryFeature();
initApiSettingsFeature();
initApiAdvancedSettingsFeature();
initStorageSettingsFeature();
initNetworkEgressSettingsFeature();
initSystemSettingsFeature();
initColorPaletteFeature();
initPromptColorsFeature();
initPromptSnippetsFeature();
initPromptTemplatesFeature();
initPromptFeature();
initPromptFidelityHelpFeature();
initPromptFindReplaceFeature();
initFormControlsFeature();
initOutputSettingsLockFeature();
initTaskListRenderFeature();
initTaskHistoryAnchorsFeature();
initTaskArchiveControlsFeature();
initTaskBatchControlsFeature();
initTaskActionsFeature();
initTaskSubmitFeature();
initTaskListControlsFeature();
initTaskListQueueControlsFeature();
initTaskContextMenuFeature();
initTaskNotificationsFeature();
initTaskDerivedFeature();
initTaskPreviewFeature();
initTaskFeature();
initTaskParameterInspectorFeature();
initTaskSelectionFeature();
initOverlayPopoversFeature();
initShellUiFeature();
initI18nFeature();
initThemedSelectFeature();
initProviderSelectionFeature();
initModelSelectionFeature();
initModelCatalogFeature();
initModelParametersFeature();
initModelParameterDraftFeature();
initAppVersionFeature();
initLightboxFeature();
initializeQueueFeature();
initAspectRatioControlsFeature();
initSegmentedIndicatorFeature();
window.__codexImageWebUI?.boot();
